import { translate } from '../../../ContentTranslation';
import RunItemIcon from './RunItemIcon';
import React, { Component } from 'react';
import './Progress.css';
import Nav from '../../nav/Nav';
import MainButton from '../../buttons/MainButton';
import Link from '../../utility/Link';
import Back from '../../Back';
import StoryText from '../../text/StoryText';
import Library from '../../../scene/utility/Library';
import User from '../../../User';
import Img from '../../../StableImage';
import DeckViewer from '../../../scene/view/DeckViewer';
import { Tooltip } from 'reactstrap';

import { getLanguage, read } from '../../../TextManager';

const statuses = Object.values(Library.statuses);
const champions = Object.values(Library.champions);

const dateoptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
};

export default class Progress extends Component {

  state = {
    champion: User.championSelect,
    difficulty: User.difficulty,
    noRun: null
  }

  toggleTooltip (tooltip, touch) {

    if (touch) {
      if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
        return;

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  parseTime (t) {

    let h = Math.floor(t/60);
    let m = t%60;
    let result = "";
    if (h)
      result += h + "h";
    result += m + "m";
    return result
  }

  setDifficulty (difficulty) {

    if (this.state.difficulty === difficulty)
      return;
    this.setState({difficulty});
  }

  render () {

    let champion = Library.getChampion(User.champion);

    let locked = champion.premium && !User.premium;

    let data = User.data;
    let progress = data.progress;
    let stats = data.stats;

    return (
      <div className="main-page progress-page">
        <Nav onChangeDifficulty={() => this.setState({difficulty: User.difficulty, noRun: null})}/>
        <div className="main">
          <div className={"story-background" + (locked ? " locked" : "") }>
            <Img key={champion.key} retries={3} delay={5000} src={champion.fullart}/>
          </div>
          <div className="story-champion">
            <div className="story-champion-name game-effect"><Img key={champion.key} src={"/images/level/" + champion.name + ".png"} className="keyword-icon"/>{champion.name}</div>
            
            <div className="story-stats">
              <div className="story-stat">
                <div>{translate("Level:")}</div><div>{(data.level) + " / " + (data.maxLevel)}</div>
              </div>
              <div className="story-stat">
                <div>{translate("Story bosses:")}</div><div>{(data.progress-1)}</div>
              </div>
              <div className="story-stat">
                <div>{translate("Runs:")}</div><div>{stats.runsPlayed}</div>
              </div>
              <div className="story-embark" onClick={() => { if (stats.runs.length > 0) this.setState({noRun: stats.runs.length-1}); } }>
                <div>{translate("Previous runs")}</div>
              </div>
            </div>
            
            {/*<div className="difficulty-switch">
                <div id="zen-difficulty" onPointerDown={() => this.toggleTooltip("zen-difficulty")} onClick={() => this.setDifficulty("zen")} className={"difficulty-option zen-option " + (this.state.difficulty === "zen" ? "active" : "")}><Img src="/images/zen.png"/></div>
                <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "zen-difficulty"} target="zen-difficulty" toggle={() => this.toggleTooltip("zen-difficulty")}><b>Zen mode</b><br/>Very high health and no game over. No achievements.</Tooltip>
                <div id="casual-difficulty" onPointerDown={e => e.pointerType === "touch" && this.toggleTooltip("casual-difficulty", true)} onClick={() => this.setDifficulty("casual")} className={"difficulty-option casual-option " + (this.state.difficulty === "casual" ? "active" : "")}><Img src="/images/casual.png"/></div>
                <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "casual-difficulty"} target="casual-difficulty" toggle={() => this.toggleTooltip("casual-difficulty")}><b>Casual mode</b><br/>High health and easy enemies.</Tooltip>
                <div id="challenge-difficulty" onPointerDown={e => e.pointerType === "touch" && this.toggleTooltip("challenge-difficulty", true)} onClick={() => this.setDifficulty("challenge")} className={"difficulty-option challenge-option " + (this.state.difficulty === "challenge" ? "active" : "")}><Img src="/images/challenge.png"/></div>
                <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "challenge-difficulty"} target="challenge-difficulty" toggle={() => this.toggleTooltip("challenge-difficulty")}><b>Challenge mode</b><br/>Low health and hard enemies.</Tooltip>
              </div>
            <div onClick={() => this.setState({champion: this.state.champion == 1 ? champions.length : this.state.champion - 1})} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div>
            <div onClick={() => this.setState({champion: this.state.champion % champions.length + 1})} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div>*/}
          </div>
        </div>
        {
          this.state.noRun !== null ?
          <div className="progress-run">
            <div className="progress-run-date">{ new Date(stats.runs[this.state.noRun].date).toLocaleString({ en: 'en-US', fr: 'fr-FR', jp: 'ja-JP' }[getLanguage()], dateoptions).replace(/,/, '').replace(/(\d{2})$/, '$1') }</div>
            <div className="progress-run-stats">
              <div className="progress-run-stat progress-run-companion">{ stats.runs[this.state.noRun].companion && <RunItemIcon key={this.state.noRun} type="companion" itemKey={stats.runs[this.state.noRun].companion}/> }</div>
              <div className="progress-run-stat">{ "Level: " + stats.runs[this.state.noRun].stats.level }</div>
              <div className="progress-run-stat progress-run-relics">
                { (stats.runs[this.state.noRun].relics || []).map((key, i) => <RunItemIcon key={this.state.noRun + "-" + i} type="relic" itemKey={key} power={stats.runs[this.state.noRun].power || 1}/>) }
              </div>
            </div>
            <DeckViewer deck={stats.runs[this.state.noRun].deck.map(c => {
              let card = Library.getUpgradedCard(c.key);
              return { card, status: c.status };
              })} onClose={() => this.setState({noRun: null})}/>
            { stats.runs.length > this.state.noRun + 1 ? <div onClick={() => this.setState({noRun: this.state.noRun + 1 })} className="cardbox-arrow cardbox-arrow-left"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
            { this.state.noRun > 0 ? <div onClick={() => this.setState({noRun: this.state.noRun - 1 })} className="cardbox-arrow cardbox-arrow-right"><Img alt="" src="/images/arrowhead.png"/></div> : "" }
          </div> : ""
        }
        <Back to="/play"/>
      </div>
    );
  }
}
